import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import { Button, Dropdown } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import React, { useContext, useState } from "react";
import { IconBase } from "react-icons";
import { TfiMenu } from "react-icons/tfi";
import { AiOutlineClose } from "react-icons/ai";
import { FiSettings } from "react-icons/fi";
import { LuSettings } from "react-icons/lu";
import { MdOutlineSettings, MdSettings } from "react-icons/md";
import "./ActionDropdown.css";
import { UserContext } from "../../../engine/context/User.context";

export const ActionDropdown = ({
  children,
  label = "Action",
  rule = null,
  loading = false,
  disabled = false,
}) => {
  const { user } = useContext(UserContext);

  const [onOpenChange, setOnOpenChange] = useState(false);
  let hasAccess = true;

  if (rule !== null) {
    hasAccess = userHasLevel(rule);
  }

  const isValidElement = element => {
    return element.props.children !== null;
  };

  let childrenNoNull = [];
  if (Array.isArray(children)) {
    childrenNoNull = children?.filter(e => e !== null && isValidElement(e));
  } else {
    childrenNoNull = [children];
  }

  const menuItems = React.Children.toArray(childrenNoNull).reduce(
    (acc, child, index) => {
      // push the current child
      acc.push({
        key: `item-${index}`, // modified key to be more descriptive
        label: child,
      });

      // if it's not the last child, push a divider
      if (index < React.Children.count(childrenNoNull) - 1) {
        acc.push({
          key: `divider-${index}`, // unique key for the divider
          type: "divider",
        });
      }

      return acc;
    },
    [],
  );

  return hasAccess && childrenNoNull.length > 0 ? (
    <div style={{ textAlign: "right" }}>
      <Dropdown
        trigger={["hover"]}
        disabled={loading === true || disabled}
        overlayClassName={"custom-dropdown"}
        type="primary"
        mouseEnterDelay={0.01}
        mouseLeaveDelay={1}
        menu={{
          items: menuItems,
        }}
        placement="bottom"
        onOpenChange={e => setOnOpenChange(e)}
        arrow={true}
        destroyOnHidden
      >
        <Button
          disabled={loading === true}
          loading={loading}
          type="default"
          style={{ paddingLeft: 20, paddingRight: 20 }}
          size={"large"}
        >
          Action
          <span style={{ marginLeft: 30, marginRight: 0 }}>
            {onOpenChange ? <MdSettings /> : <MdOutlineSettings />}
          </span>
        </Button>
      </Dropdown>
    </div>
  ) : null;
};
